import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { package_returndata } from 'src/types/package_returndata';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { cPackage, packageObj } from 'src/types/package';
import { MenuItem, MessageService } from 'primeng/api';
import { readiness_returndata } from 'src/types/readiness_returndata';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { BusyService } from '../_services/busy.service';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-Package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class packageComponent implements OnInit {
  ListPackage: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  Package: any;
  DisabledPackage: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  PackageObj: cPackage;
  httpResponse: any;
  id: string;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;

  //What sits under the Export button. A new export only needs a line here.
  exportItems: MenuItem[] = [
    { label: 'Price List', icon: 'pi pi-tag', command: () => this.exportPriceList() },
    { label: 'Upgrades', icon: 'pi pi-arrow-up', command: () => this.exportUpgrades() },
    { label: 'Extras', icon: 'pi pi-star', command: () => this.exportExtras() },
  ];

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService, private busyService: BusyService) {
      //this.isRowSelectable = this.isRowSelectable.bind(this);
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("PACKAGE", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
  }

  copydata(id)
  {
      this.http.get(bmxurl + "package/" + this.VenueID + "/" + id).subscribe(response => {
        this.httpResponse = response;
        this.PackageObj = {
          id: null,
          packageId: null,
          name: (this.httpResponse.data as cPackage).name,
          eventid: (this.httpResponse.data as cPackage).eventid,
          description: (this.httpResponse.data as cPackage).description,
          imageurl: (this.httpResponse.data as cPackage).imageurl,
          message: (this.httpResponse.data as cPackage).message,
          disabled: (this.httpResponse.data as cPackage).disabled,
          venueID: (this.httpResponse.data as cPackage).venueID,
          resources: (this.httpResponse.data as cPackage).resources,
          startTimes: (this.httpResponse.data as cPackage).startTimes,
          admissions: (this.httpResponse.data as cPackage).admissions,
          packageLength: (this.httpResponse.data as cPackage).packageLength,
          questionnaire: (this.httpResponse.data as cPackage).questionnaire,
          min: (this.httpResponse.data as cPackage).min,
          max: (this.httpResponse.data as cPackage).max,
          tags: (this.httpResponse.data as cPackage).tags,
          startDate: new Date((this.httpResponse.data as cPackage).startDate),
          visibility: (this.httpResponse.data as cPackage).visibility,
          endDate: new Date((this.httpResponse.data as cPackage).endDate),
          colour: (this.httpResponse.data as cPackage).colour,
          packageRule: (this.httpResponse.data as cPackage).packageRule,
          packageRestriction: (this.httpResponse.data as cPackage).packageRestriction,
          extras: (this.httpResponse.data as cPackage).extras,
          publicDepositPolicy: (this.httpResponse.data as cPackage).publicDepositPolicy,
          venueDepositPolicy: (this.httpResponse.data as cPackage).venueDepositPolicy,
          additionalresources:  (this.httpResponse.data as cPackage).additionalresources,
          confirmation:  (this.httpResponse.data as cPackage).confirmation,
          warning:  (this.httpResponse.data as cPackage).warning,
          originatingid: (this.httpResponse.data as cPackage).packageId,
          bookingscannotbemadewithinxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadewithinxminutes,
          bookingscannotbemadeafterxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadeafterxminutes,
          cannotmakebookingstoday: (this.httpResponse.data as cPackage).cannotmakebookingstoday,
          discounttype: (this.httpResponse.data as cPackage).discounttype,
          discountamount: (this.httpResponse.data as cPackage).discountamount,
          discountcode: (this.httpResponse.data as cPackage).discountcode,
          discountstart: (this.httpResponse.data as cPackage).discountstart,
          discountend: (this.httpResponse.data as cPackage).discountend,
          earlybirddiscount: (this.httpResponse.data as cPackage).earlybirddiscount,
          discountrangetype: (this.httpResponse.data as cPackage).discountrangetype,
          discountdaysbefore: (this.httpResponse.data as cPackage).discountdaysbefore,
          imageguid: (this.httpResponse.data as cPackage).imageguid,
          bookingtimeout: (this.httpResponse.data as cPackage).bookingtimeout,
          maxcalendarmonths: (this.httpResponse.data as cPackage).maxcalendarmonths,
          packageupgrades: (this.httpResponse.data as cPackage).packageupgrades,
          packageabupgrades: (this.httpResponse.data as cPackage).packageabupgrades,
          waiverrequired: (this.httpResponse.data as cPackage).waiverrequired,
          ispartypackage: (this.httpResponse.data as cPackage).ispartypackage,
          bookingfeeid: (this.httpResponse.data as cPackage).bookingfeeid,
          portaltemplateid: (this.httpResponse.data as cPackage).portaltemplateid,
          cannotbepaidwithvoucher: (this.httpResponse.data as cPackage).cannotbepaidwithvoucher
        }

        //Got Package, now resave it.
        this.http.post<packageObj>(bmxurl + "/package", this.PackageObj).subscribe(response => {
          this.httpResponse = response
          if (this.httpResponse.succeeded) {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Package successfully copied' });
            this.editData(this.httpResponse.data.packageId)
          }
          else
          {
            this.messageService.add({ severity: 'error', summary: 'Error Copying Package', detail: this.httpResponse.messages[0] });
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Error Copying Package', detail: error.messages });
        })


      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error Copying Package'});
      });
      
  }

  addNewPackage(){

    let readiness;
    let allowPackageAdd = false;

    this.http.get(bmxurl + "readiness/" + this.VenueID).subscribe(response => {
      if((response as readiness_returndata).succeeded == true)
      {
        readiness = (response as readiness_returndata).data;
        if(readiness.admissions == true && readiness.confirmations == true && readiness.deposits == true && readiness.resources == true && readiness.venuestarttimes == true)
        {
          this.router.navigateByUrl("/packageedit/0");
        }
        else{
          if(readiness.admissions == false)
            this.messageService.add({severity:'error', summary:'Error', detail:'You must create admissions before you can create a package'});
          if(readiness.confirmations == false)
            this.messageService.add({severity:'error', summary:'Error', detail:'You must create confirmations before you can create a package'});
          if(readiness.deposits == false)   
            this.messageService.add({severity:'error', summary:'Error', detail:'You must create deposits before you can create a package'});
          if(readiness.resources == false)
            this.messageService.add({severity:'error', summary:'Error', detail:'You must create resources before you can create a package'});
          if(readiness.venuestarttimes == false)
            this.messageService.add({severity:'error', summary:'Error', detail:'You must create venuestarttimes before you can create a package'});
        }
      }
    }, error => {
    });
  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(PackageID)
  {
    this.http.delete(bmxurl + "Package/" + this.VenueID + "/" + PackageID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Package successfully disabled'});
        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Package'});
    })
  }

  /*
    Export Price List: every package on this page, set out under its package group, with a
    column for each admission and that admission's price on the package in it.

    Where the figures come from:
      - the groups, and which packages are in each, from the package group list. A group holds
        its own copy of a package, taken when it was added, so that copy is only trusted for
        membership - never for a price.
      - the prices from each package itself, fetched in full, so the list is what a customer
        would be charged today.

    A package in two groups is listed under both. One in no group is listed at the end rather
    than left out, since a missing package on a price list reads as "not for sale".
  */
  exportPriceList()
  {
    this.exportPackages("price list", "price_list", sections => this.priceListRows(sections));
  }

  /*
    Export Upgrades: every upgrade on every package, with the price the package charges for it,
    set out in package group order the same way the price list is. One row per upgrade, because
    packages offer different upgrades and a column for each would be mostly empty.

    A package with no upgrades is left off - on a list of upgrades it has nothing to say. The
    order of a package's upgrades is the order set on the package.
  */
  exportUpgrades()
  {
    this.exportPackages("upgrades list", "upgrades", sections => this.upgradeRows(sections));
  }

  /*
    Export Extras: the same as Export Upgrades, for the extras on each package. The price is the
    one on the package's own copy of the extra, because that is what a booking on the package
    is charged. An ad hoc (variable value) extra has no set price - staff type it in on the
    booking - so it says so rather than showing 0.00.
  */
  exportExtras()
  {
    this.exportPackages("extras list", "extras", sections => this.extraRows(sections));
  }

  /*
    What every export shares: the groups, each fetched in full for its packages, and every package
    fetched in full for its prices, then set out in sections in group order. build turns the
    sections into the rows of the file.
  */
  private exportPackages(what: string, fileName: string, build: (sections: { group: string, packages: any[] }[]) => string[][])
  {
    const packages: any[] = (this.ListPackage ?? []);

    if(packages.length == 0)
    {
      this.messageService.add({severity:'warn', summary:'Nothing to export', detail:'There are no packages to put on the ' + what + '.'});
      return;
    }

    this.busyService.busy();

    //The groups first. The list of groups does not say which packages are in each one - only
    //a group fetched on its own does - so the list gives the groups and their order, and each
    //is then fetched in full for its packages, alongside the packages themselves.
    this.http.get(bmxurl + "PackageGroupListVenue/" + this.VenueID + "/false").pipe(
      catchError(() => of(null)),
      switchMap(listed => {
        const groupList: any[] = (listed as any)?.data ?? [];

        return forkJoin({
          //A group that will not load on its own keeps whatever the list said about it.
          groups: groupList.length == 0 ? of([]) : forkJoin(groupList.map(group =>
            this.http.get(bmxurl + "/PackageGroup/" + this.VenueID + "/" + group.packagegroupid).pipe(
              map(response => (response as any)?.data ?? group),
              catchError(() => of(group))))),
          //One call per package. A package that fails to load is still listed, with no prices.
          full: forkJoin(packages.map(pkg =>
            this.http.get(bmxurl + "package/" + this.VenueID + "/" + pkg.packageId).pipe(catchError(() => of(null)))))
        });
      })
    ).subscribe(result => {
      try
      {
        const groups: any[] = (result.groups as any[])
          .slice()
          .sort((one: any, two: any) => (Number(one.order) || 0) - (Number(two.order) || 0));

        const loaded = (result.full as any[]).map((response, at) => (response as any)?.data ?? packages[at]);

        this.downloadCsv(build(this.packageSections(groups, loaded)), fileName);
      }
      catch(error)
      {
        this.messageService.add({severity:'error', summary:'Not exported', detail:'The ' + what + ' could not be built.'});
      }
      finally
      {
        this.busyService.idle();
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Not exported', detail:'An error occurred getting the packages for the ' + what + '.'});
    });
  }

  //The live packages set out under their groups, in group order, with any in no group last.
  private packageSections(groups: any[], packages: any[]): { group: string, packages: any[] }[]
  {
    const idOf = (pkg: any): string => (pkg?.packageId ?? pkg?.id ?? "").toString();

    //A group's copy of a package is matched to the live one by its package id, then by its row
    //id, then by its name - whichever the copy still agrees with the package on.
    const byKey = new Map<string, any>();

    packages.forEach(pkg => {
      [pkg?.packageId, pkg?.id].forEach(id => {
        if(id != null && id != "") { byKey.set("id:" + id, pkg); }
      });

      const name = (pkg?.name ?? "").toString().trim().toLowerCase();

      if(name != "" && !byKey.has("name:" + name)) { byKey.set("name:" + name, pkg); }
    });

    const liveFor = (member: any): any =>
      byKey.get("id:" + member?.packageId)
      ?? byKey.get("id:" + member?.id)
      ?? byKey.get("name:" + (member?.name ?? "").toString().trim().toLowerCase());

    const sections: { group: string, packages: any[] }[] = [];
    const placed = new Set<string>();

    groups.forEach(group => {
      const members = (Array.isArray(group.packages) ? group.packages : [])
        .map((member: any) => liveFor(member))
        .filter((pkg: any) => pkg != null);

      if(members.length > 0)
      {
        members.forEach((pkg: any) => placed.add(idOf(pkg)));
        sections.push({ group: (group.packagegroupname ?? "").toString(), packages: members });
      }
    });

    const loose = packages
      .filter(pkg => !placed.has(idOf(pkg)))
      .sort((one, two) => (one.name ?? "").localeCompare(two.name ?? ""));

    if(loose.length > 0)
    {
      //The name the Package Groups screen gives the same leftovers.
      sections.push({ group: "Other Packages", packages: loose });
    }

    return sections;
  }

  private priceListRows(sections: { group: string, packages: any[] }[]): string[][]
  {
    //One column per admission met, in the order met. Keyed on the admission's own id so two
    //packages selling the same admission share a column, and on the name where there is none.
    const columns: { key: string, name: string }[] = [];
    const keyOf = (adm: any): string => (adm?.admissionid ?? adm?.name ?? "").toString();

    const admissionsOf = (pkg: any): any[] =>
      (Array.isArray(pkg?.admissions) ? pkg.admissions : []).filter((adm: any) => adm.disabled != true);

    sections.forEach(section => section.packages.forEach(pkg => {
      admissionsOf(pkg).forEach(adm => {
        if(!columns.some(column => column.key == keyOf(adm)))
        {
          columns.push({ key: keyOf(adm), name: (adm.name ?? "").toString() });
        }
      });
    }));

    const rows: string[][] = [["Package Group", "Package", ...columns.map(column => column.name)]];

    sections.forEach(section => section.packages.forEach(pkg => {
      const prices = new Map<string, any>();

      admissionsOf(pkg).forEach(adm => prices.set(keyOf(adm), adm.price));

      rows.push([
        section.group,
        (pkg.name ?? "").toString(),
        //Blank where the package does not sell that admission - a 0.00 would say it was free.
        ...columns.map(column => prices.has(column.key) ? (Number(prices.get(column.key)) || 0).toFixed(2) : "")
      ]);
    }));

    return rows;
  }

  private upgradeRows(sections: { group: string, packages: any[] }[]): string[][]
  {
    const rows: string[][] = [["Package Group", "Package", "Upgrade", "Price", "Per Person"]];

    sections.forEach(section => section.packages.forEach(pkg => {
      (Array.isArray(pkg?.packageupgrades) ? pkg.packageupgrades : [])
        .filter((pu: any) => pu.disabled != true)
        .slice()
        .sort((one: any, two: any) => (Number(one.order) || 0) - (Number(two.order) || 0))
        .forEach((pu: any) => {
          rows.push([
            section.group,
            (pkg.name ?? "").toString(),
            //The name on the package first - it is what the customer is shown - then the
            //upgrade's own.
            (pu.name ?? pu.upgrade?.name ?? "").toString(),
            (Number(pu.price) || 0).toFixed(2),
            pu.perperson == true ? "Yes" : "No"
          ]);
        });
    }));

    return rows;
  }

  private extraRows(sections: { group: string, packages: any[] }[]): string[][]
  {
    const rows: string[][] = [["Package Group", "Package", "Extra", "Price", "Per Person"]];

    sections.forEach(section => section.packages.forEach(pkg => {
      //In the order the package lists them, which is the order the booking screens show them in.
      (Array.isArray(pkg?.extras) ? pkg.extras : [])
        .filter((ext: any) => ext.disabled != true)
        .forEach((ext: any) => {
          rows.push([
            section.group,
            (pkg.name ?? "").toString(),
            (ext.name ?? "").toString(),
            ext.variablevalue == true ? "Variable" : (Number(ext.price) || 0).toFixed(2),
            ext.perPerson == true ? "Yes" : "No"
          ]);
        });
    }));

    return rows;
  }

  private downloadCsv(rows: string[][], name: string)
  {
    const cell = (value: string): string => '"' + (value ?? "").replace(/"/g, '""') + '"';
    const csv = rows.map(row => row.map(cell).join(",")).join("\r\n");

    //The byte order mark is what makes Excel read the pound sign and accents correctly.
    const blob = new Blob(["\ufeff" + csv], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement("a");

    link.href = URL.createObjectURL(blob);
    link.download = name + "_" + new Date().toISOString().substring(0, 10) + ".csv";
    link.click();

    URL.revokeObjectURL(link.href);
  }

  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "packagelist/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      if((response as package_returndata).succeeded == true)
      {
        this.ListPackage = (response as package_returndata).data.filter((item: any) => item.eventid == null);

        if ((response as package_returndata).messages.length > 0)
        {
          (response as package_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
      }
    }, error => {
    });
  }

  editData(EditData)
  {
    let PackageID = EditData;
    this.router.navigateByUrl("/packageedit/" + PackageID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    //packageId, as the row button passes it - PackageID was never a property, so every ticked
    //row asked the API to delete "undefined".
    this.http.delete(bmxurl + "Package/" + this.VenueID + "/" + element.packageId).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.loadgrid(false);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Disabled', detail:'An error occurred disabling one of the Packages'});
      }
    }, error => {
      //Was empty, which is why this went unnoticed - the calls failed in silence.
      this.messageService.add({severity:'error', summary:'Not Disabled', detail:'An error occurred disabling one of the Packages'});
    })
    });

  }


  }
